/*
 * @Author: GXQ
 * @Date: 2022-01-27 23:39:48
 * @LastEditTime: 2024-11-22 20:21:28
 * @LastEditors: GXQ
 * @Description: U1
 * @FilePath: \boparadise-web-bsc\src\pages\components\bottom-nav.tsx
 */
import { useState } from "react"
import { t } from "i18next"
import { useHistory } from 'react-router-dom'
import logo from 'assets/icon/aavelogo.png'

export default function Loading(props: any) {
    
    const history = useHistory()

    

    return (
        <div className="main">
            <div className="row">
                <img src={logo} alt="logo" />
                <div>Please wait...</div>
            </div>
        </div>
    )
}